module.exports = __webpack_public_path__ + "img/logo.699cbe9c.svg";